<script setup>
import { inject } from 'vue'
import { logoDestinationKey } from '../lib/interfaceRegistry.js'

defineProps({
  defaultTo: { type: Object, default: () => ({ name: 'Home' }) },
})

const destination = inject(logoDestinationKey, null)
</script>

<template>
  <RouterLink :to="destination ?? defaultTo" class="inline-flex rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary">
    <slot />
  </RouterLink>
</template>
